import api from '../api';
import { serviceReutils } from '../../utils/reutils';

export const ServiceTipoViatura = {
  ...serviceReutils({ name: 'rotas/v1/tipoViatura', api }),
};
